var Marionette = require('backbone.marionette');

var RemoteSuggesterView = require('../common/remote-suggester-input.js');
var PhysicianFormView = require('./physician-form');
var DeterminationOfNeedRevisedView = require('./determination-of-need-revised-view');

var CommonUtils = require('../../utils/common-utils.js');
var Constants = require('../../utils/constants');

var Radio = require('backbone.radio');
var services = Radio.channel('services');
var notificationsChannel = Radio.channel('notifications');
var actionsChannel = Radio.channel('actions');

var ReferralFormView = Marionette.View.extend({
        template: require('../../templates/med-forms/referral-form.html'),

        regions: {
            languageSelect: '#language-select',
            stateSelect: '#state-select',
            countrySelect: '#country-select',
            primaryPhysicianForm: '#primary-physician-form',
            donrTable: '#don-r-table'
        },

        ui: {
            referralSourceContent: '#referral-source-content',
            profileContent: '#profile-content',
            medicalInformationContent: '#medical-information-content',
            referralDate: '#referral-date',
            referredBy: '#referred-by',
            referredByPhone: '#referred-by-phone',
            referredByEmail: '#referred-by-email',
            dob: '#dob',
            ssn: '#ssn',
            sex: '#sex',
            address: '#address',
            zip: '#zip',
            personPhone: '#person-phone',
            personEmail: '#person-email',
            housing: '#housing',
            housingDetails: '#housing-details',
            primaryContactName: '#primary-contact-name',
            primaryContactRelationship: '#primary-contact-rel',
            primaryContactPhone: '#primary-contact-phone',
            primaryContactAddress: '#primary-contact-address',

            diagnosisSearchText: '#search-text',
            diagnosisSearchButton: '#search-button',
            diagnosisTable: '#diagnosis',
            selectedDiagnosisTable: '#selected-diagnosis',
            diagnosisComments: '#diagnosis-comments',

            generalComments: '#general-comments',

            languageSelectContent: '#language-select',
            selectedLanguages: '#selected-languages',

            createReferralFormBtn: '#create',
            countrySelect: '#country-select',
            countySelect: '#county-select',

            otherPhysicians: '#other-physicians',
            addPhysician: '#add-physician',

            reCaptcha: '#re-captcha'
        },

        events: {
            'click @ui.createReferralFormBtn': 'onCreate',
            'change .simple-input': 'onChangeSimpleInput',
            'change @ui.referredByPhone': 'onReferredByPhoneChanged',
            'change @ui.referredByEmail': 'onReferredByEmailChanged',
            'change @ui.address': 'onChangeAddress',
            'change @ui.zip': 'onChangeAddress',
            'change @ui.personPhone': 'onPersonPhoneChanged',
            'change @ui.personEmail': 'onPersonEmailChanged',
            'change @ui.ssn': 'onSsnChange',
            'change @ui.housing': 'onChangeHousing',
            'change @ui.housingDetails': 'onChangeHousingDetails',
            'change .primary-contact': 'onChangePrimaryContact',
            'change @ui.primaryContactPhone': 'onPrimaryContactPhoneChanged',

            'keyup @ui.diagnosisSearchText': 'searchDiagnosis',
            'click @ui.diagnosisSearchButton': 'searchDiagnosis',
            'click .remove-diagnosis': 'onRemoveDiagnosis',
            'change @ui.diagnosisComments': 'onChangeDiagnosisComments',
            'change @ui.generalComments': 'onChangeGeneralComments',

            'click .language-primary': 'setLanguageAsPrimary',
            'click .remove-language': 'removeLanguage',

            'click @ui.addPhysician': 'addPhysician'
        },

        childViewEvents: {
            'suggestor:selected:language': 'onSelectLanguage',
            'suggestor:selected:state': 'onSelectState',
            'suggestor:selected:country': 'onSelectCountry',
            'physician:remove': 'removePhysician'
        },

        primaryLanguageColor: '#337ab7',
        secondaryLanguageColor: '#afc7dc',

        initialize: function () {
            var that = this;
            that.utils = new CommonUtils();
            that.initReferralFormData();
            that.servicesAddresses = services.request('get:services:address');

            window.setTimeout(function () {
                if (_.isUndefined(that.servicesAddresses))
                    that.servicesAddresses = services.request('get:services:address');
            }, 1000);
        },

        templateContext: function () {
            var that = this;
            return {
                housingValues: that.utils.getHousingValues()
            }
        },

        initReferralFormData: function () {
            this.referralForm = {
                person: {
                    referredByContacts: [],
                    languages: [],
                    contacts: [],
                    primaryContacts: [
                        {
                            contacts: []
                        }
                    ],
                    primaryPhysician: {},
                    physicians: []
                },
                medProfile: {
                    diseases: [],
                    determinationOfNeedRevised: this.utils.getDeterminationOfNeedRevised()
                }
            }
        },

        onRender: function () {
            window.document.title = "Referral form";
            var that = this;

            var now = new Date();

            that.ui.referralSourceContent.collapse("show");
            that.ui.profileContent.collapse("show");
            that.ui.medicalInformationContent.collapse("show");

            that.ui.referralDate.datepicker({
                format: 'mm/dd/yyyy',
                clearBtn: true
            }).on('changeDate', function (e) {
                $(this).datepicker('hide');
                that.referralForm.person.referralDate = that.utils.dateToLong(e.target.value);
            }).on('clearDate', function (e) {
                that.referralForm.person.referralDate = 0;
            });
            that.ui.referralDate.datepicker('update', now);
            that.referralForm.person.referralDate = that.utils.dateToLong(now);

            that.ui.dob.datepicker({
                format: 'mm/dd/yyyy',
                clearBtn: true
            }).on('changeDate', function (e) {
                $(this).datepicker('hide');
                that.referralForm.person.birthData = that.utils.dateToLong(e.target.value);
            }).on('clearDate', function (e) {
                that.referralForm.person.birthData = 0;
            });

            var sexSelectize = this.ui.sex.selectize({
                allowEmptyOption: false
            });

            var housingSelectize = this.ui.housing.selectize({
                allowEmptyOption: false
            });

            that.countySelect = this.ui.countySelect.selectize({
                allowEmptyOption: false,
                placeholder: 'Select a county',
                inputClass: 'form-control selectize-input',
                highlight: true,
                onChange: function (value) {
                    that.rebuildFullSimpleAddress();
                }
            });

            that.ui.referredByPhone.mask("(999) 999-9999", {
                autoclear: false,
                completed: function () {
                    that.clearError(this);
                    that.onContactChanged("referredByContacts", this.val(), 'PHONE');
                }
            });
            that.ui.ssn.mask("999-99-9999", {
                autoclear: false,
                completed: function () {
                    that.clearError(this);
                    that.referralForm.person["ssn"] = this.val();
                }
            });
            that.ui.personPhone.mask("(999) 999-9999", {
                autoclear: false,
                completed: function () {
                    that.clearError(this);
                    that.onContactChanged("contacts", this.val(), 'PHONE');
                }
            });
            that.ui.primaryContactPhone.mask("(999) 999-9999", {
                autoclear: false,
                completed: function () {
                    that.clearError(this);
                    that.primaryContactPhoneChange(this.val());
                }
            });

            that.showlanguageSelect();
            that.showStateSelect();
            that.showCountrySelect();
            that.showPrimaryPhysician();
            that.showDonRTable();

            that.disableSeparateFields();

            window.setTimeout(function () {
                that.initAddressesSuggest();
            }, 1000);

            window.setTimeout(function () {
                that.initReCaptcha();
            }, 1000);

        },

        initReCaptcha: function () {
            var that = this;
            that.recaptcha = window.grecaptcha.render(that.ui.reCaptcha.get(0), {
                'sitekey': Constants.googleRecaptchaKey,
                'callback': function (response) {
                    if (!_.isEmpty(response)) {
                        that.recaptchaResponse = response;
                    }
                }
            });
        },

        recaptchaReset: function () {
            window.grecaptcha.reset(this.recaptcha);
            this.recaptchaResponse = '';
        },

        initAddressesSuggest: function () {
            var that = this;
            var clientAddressDomEl = that.ui.address.get(0);
            var primaryContactAddressDomEl = that.ui.primaryContactAddress.get(0);
            var options = {
                types: ['address'],
                componentRestrictions: {country: 'us'}
            };

            var addressParser = function (place) {
                var addressComponents = {
                    street_number: 'short_name',
                    route: 'long_name',
                    locality: 'long_name',
                    administrative_area_level_3: 'short_name',
                    administrative_area_level_2: 'short_name',
                    administrative_area_level_1: 'short_name',
                    country: 'short_name',
                    postal_code: 'short_name'
                };

                var addressParts = [];

                for (var i = 0; i < place.address_components.length; i++) {
                    var addressType = place.address_components[i].types[0];
                    if (addressComponents[addressType]) {
                        addressParts.push(place.address_components[i][addressComponents[addressType]]);
                    }
                }

                return addressParts.join(', ');
            };

            that.clientAddressAutocomplete = new google.maps.places.Autocomplete(clientAddressDomEl, options);
            that.clientAddressAutocomplete.addListener('place_changed', function () {
                var place = that.clientAddressAutocomplete.getPlace();
                var address = addressParser(place);
                that.rebuildFullSimpleAddress();
            });

            that.primaryContactAddressAutocomplete = new google.maps.places.Autocomplete(primaryContactAddressDomEl, options);
            that.primaryContactAddressAutocomplete.addListener('place_changed', function () {
                var place = that.primaryContactAddressAutocomplete.getPlace();
                var address = addressParser(place);
                that.referralForm.person.primaryContacts[0]["address"] = address;
            });
        },

        disableSeparateFields: function () {
            var that = this;
            window.setTimeout(function () {
                that.ui.countrySelect.find('#country').attr('disabled', true);
            }, 500);
        },

        onChangeSimpleInput: function (event) {
            this.referralForm.person[event.target.name] = event.target.value;
        },

        onReferredByPhoneChanged: function (event) {
            if (event.target.value.indexOf('_') > -1) {
                this.showError($(event.target), "Uncompleted");
                this.onContactChanged("referredByContacts", '', 'PHONE');
            } else if (_.isEmpty(event.target.value)) {
                this.clearError($(event.target));
                this.onContactChanged("referredByContacts", '', 'PHONE');
            }
        },

        onReferredByEmailChanged: function (event) {
            var val = event.target.value;
            if (this.utils.isValidEmail(val) || _.isEmpty(val)) {
                this.onContactChanged("referredByContacts", val, 'EMAIL');
                this.clearError($(event.target));
            } else {
                this.onContactChanged("referredByContacts", '', 'EMAIL');
                this.showError($(event.target), "Invalid e-mail");
            }
        },

        onPersonPhoneChanged: function (event) {

            if (event.target.value.indexOf('_') > -1) {
                this.showError($(event.target), "Uncompleted");
                this.onContactChanged("contacts", '', 'PHONE');
            } else if (_.isEmpty(event.target.value)) {
                this.clearError($(event.target));
                this.onContactChanged("contacts", '', 'PHONE');
            }
        },

        onSsnChange: function (event) {

            if (event.target.value.indexOf('_') > -1) {
                this.showError($(event.target), "Uncompleted");
                this.referralForm.person["ssn"] = "";
            } else if (_.isEmpty(event.target.value)) {
                this.clearError($(event.target));
                this.referralForm.person["ssn"] = "";
            }
        },

        onPersonEmailChanged: function (event) {
            var val = event.target.value;
            if (this.utils.isValidEmail(val) || _.isEmpty(val)) {
                this.onContactChanged("contacts", val, 'EMAIL');
                this.clearError($(event.target));
            } else {
                this.onContactChanged("contacts", '', 'EMAIL');
                this.showError($(event.target), "Invalid e-mail");
            }
        },

        onContactChanged: function (contactField, val, contactType) {
            if (_.isEmpty(val)) {
                this.referralForm.person[contactField] = this.referralForm.person[contactField].filter(function (contact) {
                    return contact.type != contactType;
                });
            } else {
                if (_.isUndefined(_.findWhere(this.referralForm.person[contactField], {type: contactType})))
                    this.referralForm.person[contactField].push({
                        data: val,
                        type: contactType
                    });
                else
                    this.referralForm.person[contactField].forEach(function (contact) {
                        if (contact.type == contactType)
                            contact.data = val;
                    });
            }
        },

        onChangeAddress: function () {
            this.rebuildFullSimpleAddress();
        },

        onSelectState: function (selected) {
            var that = this;
            if (_.isEmpty(selected) || _.isNull(selected) || _.isUndefined(selected)) {
                that.countySelect[0].selectize.clearOptions();
            } else {
                $.ajax({
                    type: "GET",
                    url: '/api/reference/counties/' + selected,
                    contentType: 'application/json',
                    statusCode: {
                        200: function (response) {
                            that.countySelect[0].selectize.clearOptions();
                            response.forEach(function (county) {
                                that.countySelect[0].selectize.addOption({
                                    value: county,
                                    text: county
                                });
                            });
                        }
                    },
                    error: function (e) {
                        if (e.status == 401) {
                            actionsChannel.request("redirect:to:login");
                        } else {
                            that.countySelect[0].selectize.clearOptions();
                            console.log(e);
                        }
                    }
                });
            }
            this.rebuildFullSimpleAddress();
        },

        onSelectCountry: function (selected) {
            this.rebuildFullSimpleAddress();
        },

        rebuildFullSimpleAddress: function () {
            var address = this.ui.address.val();
            var county = this.ui.countySelect.val();
            var state = this.getChildView('stateSelect').getSelectedId();
            var zip = this.ui.zip.val();
            var country = this.getChildView('countrySelect').getSelectedId();

            var fullSipmleAddress = [address, county, state, zip, country].filter(function (item) {
                return !_.isEmpty(item) && !_.isNull(item) && !_.isUndefined(item);
            });
            this.referralForm.person.address = fullSipmleAddress.join(", ");
        },

        onChangeHousing: function (event) {
            var that = this;
            var housing = event.target.value;
            that.referralForm.person.housing = housing;

            if (housing != 'Other') {
                this.ui.housingDetails.parent().parent().hide();
                that.referralForm.person.housingDetails = '';
                this.ui.housingDetails.val();
            } else {
                this.ui.housingDetails.parent().parent().show();
            }
        },

        onChangeHousingDetails: function (event) {
            this.referralForm.person.housingDetails = event.target.value;
        },

        onChangePrimaryContact: function (event) {
            this.referralForm.person.primaryContacts[0][event.target.name] = event.target.value;
        },

        onPrimaryContactPhoneChanged: function (event) {
            if (event.target.value.indexOf('_') > -1) {
                this.showError($(event.target), "Uncompleted");
                this.primaryContactPhoneChange('');
            } else if (_.isEmpty(event.target.value)) {
                this.clearError($(event.target));
                this.primaryContactPhoneChange('');
            }
        },

        primaryContactPhoneChange: function (val) {
            var contactType = 'PHONE';
            if (_.isEmpty(val)) {
                this.referralForm.person.primaryContacts[0].contacts = this.referralForm.person.primaryContacts[0].contacts.filter(function (contact) {
                    return contact.type != contactType;
                });
            } else {
                if (_.isUndefined(_.findWhere(this.referralForm.person.primaryContacts[0].contacts, {type: contactType})))
                    this.referralForm.person.primaryContacts[0].contacts.push({
                        data: val,
                        type: contactType
                    });
                else
                    this.referralForm.person.primaryContacts[0].contacts.forEach(function (contact) {
                        if (contact.type == contactType)
                            contact.data = val;
                    });
            }
        },

        validateReferralForm: function () {

            if (this.getErrorsCount() > 0)
                return "Some fields with errors";

            if (!this.referralForm.person.firstName || _.isEmpty(this.referralForm.person.firstName
                    || !this.referralForm.person.lastName && _.isEmpty(this.referralForm.person.lastName)))
                return 'Please, fill first name and last name of prospective client';

            if (_.isEmpty(this.recaptchaResponse))
                return "Check the recaptcha";

            return "";
        },

        getErrorsCount: function () {
            return this.$el.find('.has-error').length;
        },

        onCreate: function () {
            var that = this;
            console.log(that.referralForm);

            var errorText = that.validateReferralForm();
            if (!_.isEmpty(errorText)) {
                notificationsChannel.request('show:notification', errorText);
                return;
            }


            that.utils.showSpinner();
            $.ajax({
                type: "POST",
                url: '/api/cmform',
                data: JSON.stringify(that.referralForm),
                contentType: 'application/json',
                statusCode: {
                    200: function (response) {
                        that.utils.hideSpinner();
                        $.notify("Referral form created successfully", "success");
                        that.initReferralFormData();
                        that.render();
                        that.recaptchaReset();
                    }
                },
                error: function (e) {
                    that.utils.hideSpinner();
                    notificationsChannel.request('show:notification', JSON.parse(e.responseText));
                }
            });
        },

        showlanguageSelect: function () {
            var that = this;

            that.showChildView('languageSelect', new RemoteSuggesterView({
                tag: 'language',
                inputId: 'language',
                maxNumberOfElements: 20,
                url: '/api/reference/languages/~~~',
                symbolForSearchInUrl: '~~~',
                listLocation: function (data) {
                    return data;
                },
                getIdFn: function (element) {
                    return element;
                },
                getValueFn: function (element) {
                    return element;
                },
                classes: ["form-control"],
                placeholder: "Select language",
                findSelectedIdBySelectedIndex: function (arr, index) {
                    return arr[index] || null;
                }
            }));
        },

        showStateSelect: function () {
            var that = this;

            that.showChildView('stateSelect', new RemoteSuggesterView({
                tag: 'state',
                inputId: 'state',
                maxNumberOfElements: 20,
                url: '/api/reference/states/~~~',
                symbolForSearchInUrl: '~~~',
                listLocation: function (data) {
                    return data;
                },
                getValueFn: function (element) {
                    return element;
                },
                classes: ["form-control"],
                placeholder: "Select state",
                findSelectedIdBySelectedIndex: function (arr, index) {
                    return arr[index] || null;
                }
            }));
        },

        showCountrySelect: function () {
            var that = this;

            that.showChildView('countrySelect', new RemoteSuggesterView({
                tag: 'country',
                inputId: 'country',
                maxNumberOfElements: 20,
                url: '/api/reference/countries/~~~',
                symbolForSearchInUrl: '~~~',
                listLocation: function (data) {
                    return data;
                },
                getValueFn: function (element) {
                    return element;
                },
                classes: ["form-control"],
                placeholder: "Select country",
                findSelectedIdBySelectedIndex: function (arr, index) {
                    return arr[index] || null;
                },
                defaultSelected: 'United States'
            }));

            window.setTimeout(function () {
                that.rebuildFullSimpleAddress();
            }, 500);
        },

        showPrimaryPhysician: function () {
            this.showChildView('primaryPhysicianForm', new PhysicianFormView({
                showRemove: false,
                physician: this.referralForm.person.primaryPhysician
            }));
        },

        showDonRTable: function () {
            this.showChildView('donrTable', new DeterminationOfNeedRevisedView({
                determinationOfNeedRevised: this.referralForm.medProfile.determinationOfNeedRevised,
                isEditMode: true
            }));
        },

        onSelectLanguage: function (lang) {
            var that = this;
            if (!_.isNull(lang) && _.isUndefined(_.findWhere(that.referralForm.person.languages, {language: lang}))) {
                that.referralForm.person.languages.push({
                    language: lang,
                    primary: false
                });
                var liContent = "<li class='list-group-item' id='" + that.langToId(lang) + "'>"
                    + "<div class='row'>"
                    + "<div class='col-xs-5 col-md-5'>"
                    + lang + ""
                    + "</div>"
                    + "<div class='col-xs-5 col-md-5'>"
                    + "Primary? <input type='checkbox' class='language-primary' title='Set as primary' style='margin-left:10px;'/> "
                    + "</div>"
                    + "<div class='col-xs-1 col-md-1'>"
                    + "<span class='glyphicon glyphicon-remove clickable remove-language' title='Remove' style='margin-left:10px;'/> "
                    + "</div>"
                    + "</div>"
                    + "</li>";
                that.ui.selectedLanguages.append(liContent);
            }
        },

        setLanguageAsPrimary: function (event) {
            var that = this;
            var currentLiEl = $(event.target).closest('li');
            var lang = that.idToLang(currentLiEl.attr('id'));
            if (event.target.checked == true) {
                currentLiEl.parent().find('li').each(function () {
                    var currentLi = $(this);
                    if (lang != that.idToLang(currentLi.attr('id'))) {
                        currentLi.find('.language-primary').prop('checked', false);
                    }
                });
            }

            that.referralForm.person.languages.forEach(function (language) {
                if (language.language == lang)
                    language.primary = event.target.checked;
                else
                    language.primary = false;
            });
        },

        removeLanguage: function (event) {
            var that = this;
            var li = $(event.target).closest('li');
            var lang = that.idToLang(li.attr('id'));
            that.referralForm.person.languages = that.referralForm.person.languages.filter(function (language) {
                return language.language != lang;
            });
            li.remove();
        },

        langToId: function (lang) {
            return lang.replace(' ', '_');
        },

        idToLang: function (lang) {
            return lang.replace('_', ' ');
        },

        searchDiagnosis: function (event) {
            var that = this;

            var searchText = that.ui.diagnosisSearchText.val();
            if (searchText.length <= 1) return;

            that.ui.diagnosisTable.find('tr:not(:first)').remove();

            //$('#search-results tr:not(:first)').remove();

            if (event.keyCode == 13 || event.target.id == that.ui.diagnosisSearchButton.attr('id')) {

                if (typeof that.servicesAddresses["icdServiceAddress"] != "undefined") {
                    that.ui.diagnosisSearchText.addClass('data-loader');
                    $.when(
                        $.ajax({
                            type: "GET",
                            url: that.servicesAddresses["icdServiceAddress"] +
                            '/search?terms=' + searchText
                        })
                    ).done(function (resp) {
                        that.resfreshDiagnosisTableFromICDResults(resp || []);
                        that.ui.diagnosisSearchText.removeClass('data-loader');
                    }).fail(function (jqXHR, textStatus) {
                        that.ui.diagnosisSearchText.removeClass('data-loader');
                        notificationsChannel.request('show:notification', "Error. ICD service is unavailable");
                    });
                }
            }
        },

        resfreshDiagnosisTableFromICDResults: function (results) {
            var that = this;
            var icdName = "ICD";

            results.forEach(function (item) {
                var newRowContent = "<tr class='clickable' id='" + item.code +
                    "'><td><button class='add-to-left' title='Add to selected'>Add</button></td><td>" + icdName + "-"
                    + item.version + "</td><td>"
                    + item.code + "</td><td>" + item.name + "</td></tr>";
                that.ui.diagnosisTable.find('tbody').append(newRowContent);
            });

            that.ui.diagnosisTable.find('tr:not(:first)').on('dblclick', function (event) {
                var id = event.currentTarget.id;
                $(this).addClass('selected').siblings().removeClass('selected');
                that.onDiagnosisSelected(id, results, icdName);
            });
            that.ui.diagnosisTable.find('.add-to-left').on('click', function (event) {
                var id = $(event.currentTarget).parent().parent().attr('id');
                that.onDiagnosisSelected(id, results, icdName);
            });
        },

        onDiagnosisSelected: function (selectedId, results, type) {
            var selected = _.findWhere(results, {code: selectedId});

            var alreadyExists = _.findWhere(this.referralForm.medProfile.diseases, {diseaseId: selectedId});
            if (!_.isUndefined(alreadyExists))
                return;

            this.referralForm.medProfile.diseases.push({
                typeOfId: type + '-' + selected.version,
                diseaseId: selected.code,
                name: selected.name
            });

            var newRowContent = "<tr class='clickable' id='" + selected.code + "'><td>ICD-"
                + selected.version + "</td><td>"
                + selected.code + "</td><td>"
                + selected.name + "</td><td><span class='glyphicon glyphicon-remove clickable remove-diagnosis' title='Remove'/></td></tr>";
            this.ui.selectedDiagnosisTable.find('tbody').append(newRowContent);
        },

        onRemoveDiagnosis: function (event) {
            var row = $(event.target);
            var diagnosisId = row.parent().parent().attr('id');
            this.referralForm.medProfile.diseases = this.referralForm.medProfile.diseases.filter(function (d) {
                return d.diseaseId != diagnosisId;
            });
            this.ui.selectedDiagnosisTable.find('tr[id="' + diagnosisId + '"]').remove();
        },

        onChangeDiagnosisComments: function (event) {
            this.referralForm.medProfile.diagnosisComments = event.target.value;
        },

        onChangeGeneralComments: function (event) {
            this.referralForm.person.generalComments = event.target.value;
        },

        addPhysician: function () {
            var physician = this.initAndGetPhysician();
            this.referralForm.person.physicians.push(physician);
            var newRegionId = _.uniqueId('physician');
            this.ui.otherPhysicians.append('<div id="' + newRegionId + '" class="form-group"></div>');
            this.addRegion(newRegionId, "#" + newRegionId);
            this.storeRegion(newRegionId);
            this.showChildView(newRegionId, new PhysicianFormView({
                showRemove: true,
                physician: physician,
                regionId: newRegionId
            }));
        },

        removePhysician: function (data) {

            var that = this;
            var regionId = data.regionId;
            var physician = data.physician;
            that.getRegion(regionId).empty();
            that.removeRegion(regionId);
            that.$('#' + regionId).remove();
            this.otherPhysiciansRegions = this.otherPhysiciansRegions.filter(function (item) {
                return item !== regionId;
            });
            that.referralForm.person.physicians = that.referralForm.person.physicians.filter(function (item) {
                return item !== physician;
            });
        },

        storeRegion: function (regionName) {
            this.otherPhysiciansRegions = this.otherPhysiciansRegions || [];
            this.otherPhysiciansRegions.push(regionName);
        },

        initAndGetPhysician: function () {
            return {
                dateOfLastVisit: 0,
                name: '',
                relationship: ''
            };
        },

        enableCreateButton: function () {
            this.ui.createReferralFormBtn.removeAttr('disabled');
        },

        disableCreateButton: function () {
            this.ui.createReferralFormBtn.attr('disabled', true);
        },

        showError: function (jQelement, text) {
            jQelement.tooltip({title: text});
            jQelement.parent().parent().addClass('has-error has-feedback');
        },

        clearError: function (jQelement) {
            jQelement.tooltip("destroy");
            jQelement.parent().parent().removeClass('has-error has-feedback');
        }
    })
;

module.exports = ReferralFormView;


//////////////////
// WEBPACK FOOTER
// ./app/views/med-forms/referral-form-view.js
// module id = 514
// module chunks = 0